export default function Login() {
  window.location.href = `${process.env.REACT_APP_API_URL}/auth/v2/ping/redirect`;

  return null;
}
